export default __webpack_public_path__ + "static/media/contact.2210b9af.svg";